<template>
  <div class="linkListFilterPanel">
    <div class="commandDeck">
      <div class="commandDeck__zone commandDeck__zone--filters">
        <div class="filterDeckHeader">
          <div class="filterDeckHeader__leading">
            <slot name="leading">
              <span class="zoneHeader__title">筛选条件</span>
            </slot>
          </div>
          <div class="actionBar">
            <el-button
              class="actionButton actionButtonQuery"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="$emit('search')"
            >
              查询
            </el-button>
            <el-button
              class="actionButton actionButtonGhost actionButton--reset"
              size="small"
              icon="el-icon-refresh-left"
              @click="$emit('reset')"
            >
              重置
            </el-button>
          </div>
        </div>

        <template v-if="profile !== 'widget'">
          <div class="filterGrid filterGrid--primary">
            <div class="filterField">
              <label class="filterField__label">资源名称</label>
              <el-input
                class="filterControl"
                placeholder="请输入资源名称"
                prefix-icon="el-icon-search"
                :value="name"
                size="small"
                clearable
                @input="$emit('update:name', $event)"
                @keydown.enter.native="$emit('search')"
              />
            </div>
            <div class="filterField">
              <label class="filterField__label">资源类型</label>
              <el-select
                v-if="isHighlightType"
                class="filterControl"
                popper-class="linkListFilterDropdown"
                :value="wallpaperType"
                placeholder="请选择"
                size="small"
                clearable
                @change="pick('wallpaperType', $event)"
              >
                <el-option label="highlight 资源" value="14" />
                <el-option label="bar sticker - 小" value="1" />
                <el-option label="bar sticker - 大" value="2" />
                <el-option label="charging icon" value="3" />
              </el-select>
              <ResourceTypePicker
                v-else
                class="filterControl"
                :value="wallpaperType"
                :types="typeOptions"
                :sort-types="sortTypeOptions"
                placeholder="请选择"
                size="small"
                @change="pick('wallpaperType', $event)"
              />
            </div>
            <div class="filterField">
              <label class="filterField__label">资源状态</label>
              <el-select
                class="filterControl"
                popper-class="linkListFilterDropdown"
                :value="wallpaperStatus"
                placeholder="请选择"
                size="small"
                clearable
                @change="pick('wallpaperStatus', $event)"
              >
                <el-option
                  v-for="item in wallpaperStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="filterGrid filterGrid--secondary">
            <div class="filterField">
              <label class="filterField__label">数据集解锁组</label>
              <el-select
                class="filterControl"
                popper-class="linkListFilterDropdown"
                :value="dataSetId"
                placeholder="请选择"
                size="small"
                clearable
                filterable
                @change="pick('dataSetId', $event)"
              >
                <el-option
                  v-for="item in dataOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="filterField">
              <label class="filterField__label">数据集筛选</label>
              <el-select
                class="filterControl"
                popper-class="linkListFilterDropdown"
                :value="dataSetIds"
                placeholder="请选择"
                size="small"
                clearable
                multiple
                collapse-tags
                filterable
                @change="onDataSetIdsChange"
                @visible-change="onDataSetIdsVisible"
              >
                <el-option
                  v-for="item in dataOptions"
                  :key="'multi-' + item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="filterGrid filterGrid--primary">
            <div class="filterField">
              <label class="filterField__label">Widget 名称</label>
              <el-input
                class="filterControl"
                placeholder="请输入 Widget 名称"
                prefix-icon="el-icon-search"
                :value="name"
                size="small"
                clearable
                @input="$emit('update:name', $event)"
                @keydown.enter.native="$emit('search')"
              />
            </div>
            <div class="filterField">
              <label class="filterField__label">资源状态</label>
              <el-select
                class="filterControl"
                popper-class="linkListFilterDropdown"
                :value="wallpaperStatus"
                placeholder="请选择"
                size="small"
                clearable
                @change="pick('wallpaperStatus', $event)"
              >
                <el-option
                  v-for="item in wallpaperStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="filterField">
              <label class="filterField__label">资源类型 (iOS)</label>
              <el-select
                class="filterControl"
                popper-class="linkListFilterDropdown"
                :value="wallpaperType"
                placeholder="请选择"
                size="small"
                clearable
                @change="pick('wallpaperType', $event)"
              >
                <el-option v-for="item in typeOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </div>
          </div>
          <div class="filterGrid filterGrid--secondary">
            <div class="filterField">
              <label class="filterField__label">资源类型 (Android)</label>
              <el-select
                class="filterControl"
                popper-class="linkListFilterDropdown"
                :value="androidType"
                placeholder="请选择"
                size="small"
                clearable
                @change="pick('androidType', $event)"
              >
                <el-option
                  v-for="item in androidTypeOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </div>
            <div class="filterField">
              <label class="filterField__label">数据集</label>
              <el-select
                class="filterControl"
                popper-class="linkListFilterDropdown"
                :value="dataSetId"
                placeholder="请选择"
                size="small"
                clearable
                filterable
                @change="pick('dataSetId', $event)"
              >
                <el-option
                  v-for="item in dataOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="filterField">
              <label class="filterField__label">数据集筛选</label>
              <el-select
                class="filterControl"
                popper-class="linkListFilterDropdown"
                :value="dataSetIds"
                placeholder="请选择"
                size="small"
                clearable
                multiple
                collapse-tags
                filterable
                @change="onDataSetIdsChange"
                @visible-change="onDataSetIdsVisible"
              >
                <el-option
                  v-for="item in dataOptions"
                  :key="'w-' + item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceTypePicker from '../../resourceManage/genericResourceManage/ResourceTypePicker.vue'

export default {
  name: 'ClassifyResourcesFilterPanel',
  components: { ResourceTypePicker },
  props: {
    profile: { type: String, default: 'default' },
    isHighlightType: { type: Boolean, default: false },
    name: { type: String, default: '' },
    wallpaperType: { type: String, default: '' },
    androidType: { type: String, default: '' },
    wallpaperStatus: { type: String, default: '' },
    dataSetId: { type: [String, Number], default: '' },
    dataSetIds: { type: Array, default: () => [] },
    typeOptions: { type: Array, default: () => [] },
    /** 通用资源分类按字母排单选类型；壁纸分类的写死列表保持原顺序。 */
    sortTypeOptions: { type: Boolean, default: false },
    androidTypeOptions: { type: Array, default: () => [] },
    dataOptions: { type: Array, default: () => [] },
    wallpaperStatusOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      dataSetIdsOpen: false,
      dataSetIdsChanged: false,
    }
  },
  methods: {
    /** 下拉选完即查，和资源管理列表一致；名称输入框仍按回车或点查询 */
    pick(field, value) {
      this.$emit(`update:${field}`, value)
      this.$emit('search')
    },
    // 数据集多选：下拉开着时每勾一项只记值，收起时查一次；下拉关着时点标签的 × 或清空就立刻查
    onDataSetIdsChange(value) {
      this.$emit('update:dataSetIds', value)
      if (this.dataSetIdsOpen) {
        this.dataSetIdsChanged = true
      } else {
        this.$emit('search')
      }
    },
    onDataSetIdsVisible(open) {
      this.dataSetIdsOpen = open
      if (!open && this.dataSetIdsChanged) {
        this.dataSetIdsChanged = false
        this.$emit('search')
      }
    },
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkListTheme.css';
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';

.linkListFilterPanel {
  padding: 0;
  background: transparent;
}

.filterGrid {
  display: grid;
  gap: 12px 16px;
}

.filterGrid + .filterGrid {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--link-line, #eee9e2);
}

.filterGrid--primary {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.filterGrid--secondary {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.filterGrid--secondary:has(.filterField:nth-child(3)) {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.filterField {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.filterField__label {
  font-family: var(--link-font-family);
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-medium);
  color: var(--link-ink-secondary);
  line-height: 1.2;
}

.filterControl {
  width: 100%;
  min-width: 0;
}

.filterDeckHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.filterDeckHeader__leading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
}

.actionBar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
}

@media (max-width: 1100px) {
  .filterGrid--primary,
  .filterGrid--secondary,
  .filterGrid--secondary:has(.filterField:nth-child(3)) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .filterGrid--primary,
  .filterGrid--secondary,
  .filterGrid--secondary:has(.filterField:nth-child(3)) {
    grid-template-columns: 1fr;
  }

  .filterDeckHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .actionBar {
    justify-content: flex-start;
  }
}
</style>
